import { useTranslations } from '@vocab/react';
import { Inline, Tag, Text, TextLinkButton } from 'braid-design-system';
import { useState, type FC } from 'react';

import translations from './.vocab';

interface TagsListProps {
  names: string[];
}

export const TagsList: FC<TagsListProps> = ({ names }) => {
  const { t } = useTranslations(translations);
  const [allSelectedNamesShown, setAllSelectedNamesShown] = useState(false);
  const shownJobApplicationNames = allSelectedNamesShown
    ? names
    : names.slice(0, 10);

  const remainingSelectedApplicationCount =
    names.length - shownJobApplicationNames.length;

  return (
    <Inline space="xsmall" alignY="center">
      {shownJobApplicationNames.map((name, index) => (
        <Tag size="small" key={index}>
          {name}
        </Tag>
      ))}
      {names.length > 10 ? (
        <Text>
          <TextLinkButton
            onClick={() => {
              setAllSelectedNamesShown((prevState) => !prevState);
            }}
          >
            {allSelectedNamesShown
              ? t('Show less')
              : t('Show {remainingSelectedApplicationCount} more', {
                  remainingSelectedApplicationCount,
                })}
          </TextLinkButton>
        </Text>
      ) : null}
    </Inline>
  );
};
